import React from "react";

const JQuery_Home = () => {
  return (
    <div>
      <h1>JQuery_Home</h1>
      <p>Placeholder component for: "JQuery_Home"</p>
    </div>
  );
};

export default JQuery_Home;
